import type { FiltersCatalogSliceState } from './filtersCatalog.types'

export const createEmptyFiltersCatalogState = (): FiltersCatalogSliceState => ({
  filters: [],
  loading: false,
  error: null,
  reorderingFilterId: null,
})
